module.exports = __webpack_public_path__ + "img/PB_HalfStrap_Image_MitPunktenZahlen_freigestellt_S.b36fa3ac.png";